import { TrackingAnalytics } from './TrackingAnalytics';
import _ from 'lodash';

const Published = (name) => {
  return `CR-Published-${name}`;
};

const Customize = (name) => {
  return `CR-Customize-${name}`;
};

const CustomizeFunnel = (name) => {
  return `CR>Customize>${name}`;
};

const CustomizeIndirectAction = (name) => {
  return `CR~Customize~${name}`;
};

const createDocumentSectionsPayload = (creatorReport) => {
  const payload = {
    noteworthy: creatorReport.isNoteworthyResponsesEnabled(),
    most_popular: creatorReport.isAllResponsesEnabled(),
    top_five: creatorReport.isTopResponsesEnabled(),
    sentiment: creatorReport.isCommentsBySentimentEnabled(),
    sentiment_by_rating: creatorReport.isSentimentByRatingEnabled(),
    statistics: creatorReport.isStatsEnabled(),
    segmentation: creatorReport.isSegmentationEnabled(),
    historical_trend: creatorReport.isHistoricalTrendEnabled()
  };
  let i = 0;
  _.each(creatorReport.state.sections, (s) => {
    const key = s.name;
    payload[key] = i + 1;
    i++;
  });
  return payload;
};

const concurrentEvent = (index, eventCount, next, previous, source, hero, scrollPercent) => {
  TrackingAnalytics.send('PV-Concurrent', {
    concurrent_index: index,
    concurrent_count: eventCount,
    source_web: 'react',
    source,
    next,
    previous,
    question_hero: hero,
    scroll_percent: (!scrollPercent || isNaN(scrollPercent)) ? TrackingAnalytics.NA : scrollPercent
  });
};

export const CreatorReportAnalytics = {
  concurrentSwitcherButtonClicked (index, eventCount, next, previous, hero, scrollPercent) {
    concurrentEvent(index, eventCount, next, previous, 'nav', hero, scrollPercent);
  },
  concurrentSwitcherArrowClicked (index, eventCount, next, previous, hero, scrollPercent) {
    concurrentEvent(index, eventCount, next, previous, 'button', hero, scrollPercent);
  },
  trackPageViewed (eventId) {
    TrackingAnalytics.trackPageViewed(eventId, 'participant_responses_list');
  },
  trackScrolledToBottom (elementRef, eventId, propertyObject) {
    TrackingAnalytics.trackPageScrolledToBottom(elementRef, eventId, 'question_results',
      propertyObject);
  },
  customizeClicked () {
    const name = Published('Customize');
    TrackingAnalytics.send(name);
  },
  topFiveClicked () {
    const name = Published('Top Five');
    TrackingAnalytics.send(name);
  },
  noteworthyCommentClicked () {
    const name = Published('Noteworthy Comment');
    TrackingAnalytics.send(name);
  },
  exportReport (report) {
    const name = Published(report);
    TrackingAnalytics.send(name);
  },
  exportReportModalOpened() {
    const name = Published('Export Report clicked');
    TrackingAnalytics.send(name);
  },
  exportReportModalClosed (exitState) {
    const name = Published('Export Report modal closed');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  historicalTrendClicked (index) {
    const name = Published('Historical Trend');
    TrackingAnalytics.send(name, { index });
  },
  userDidEnterCustomize () {
    const name = CustomizeFunnel('Enter');
    TrackingAnalytics.send(name);
  },
  customizeInfoIconClicked () {
    const name = Customize('Customize Info Icon');
    TrackingAnalytics.send(name);
  },
  customizeCancelClicked (creatorReport) {
    const name = Customize('Cancel');
    const payload = createDocumentSectionsPayload(creatorReport);
    TrackingAnalytics.send(name, payload);
  },
  customizeExitPublish () {
    this.customizeExit('publish');
  },
  customizeExitCancel () {
    this.customizeExit('cancel');
  },
  customizeExit (exitState) {
    const name = CustomizeFunnel('Exit');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  customizePublishedClicked (creatorReport) {
    // close the funnel
    this.customizeExitPublish();

    // track the individual button click
    const name = Customize('Publish');
    const payload = createDocumentSectionsPayload(creatorReport);
    TrackingAnalytics.send(name, payload);
  },
  customizeRestoreDefaults () {
    const name = Customize('Restore Defaults');
    TrackingAnalytics.send(name);
  },
  customizeRestoreDefaultsModal (exitState) {
    const name = CustomizeIndirectAction('Restore Defaults Modal');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  customizeToggleClicked (sectionName, on) {
    const name = Customize('Toggle');
    TrackingAnalytics.send(name, { section_name: sectionName, visible: on });
  },
  customizeNoteworthyInfoModal (exitState) {
    const name = CustomizeIndirectAction('Noteworthy Info Modal');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  customizeNoteworthyInfoModalLearnMore () {
    const name = Customize('Noteworthy Info Modal Learn More');
    TrackingAnalytics.send(name);
  },
  customizeNoteworthyModal (exitState) {
    const name = Customize('Noteworthy Modal');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  customizeNoNoteworthySelected (exitState) {
    const name = Customize('No Noteworthy Selected Modal');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  customizeNoteworthyModalCommentClicked (removing, totalNoteworthy) {
    const name = Customize('Noteworthy Modal Comment');
    TrackingAnalytics.send(name, { visible: !removing, total_noteworthy: totalNoteworthy });
  },
  customizeNoteworthyEditClicked () {
    const name = Customize('Edit Noteworthy');
    TrackingAnalytics.send(name);
  },
  customizeNoteworthyUnsavedChangedModal (exitState) {
    const name = CustomizeIndirectAction('Unsaved Changes Modal');
    TrackingAnalytics.send(name, { exit_state: exitState, source: 'noteworthy modal' });
  },
  customizeUnsavedChangedModal (exitState) {
    const name = CustomizeIndirectAction('Unsaved Changes Modal');
    TrackingAnalytics.send(name, { exit_state: exitState, source: 'customize view' });
  },
  customizeMoveClicked (sectionName, direction) {
    const name = Customize('Move');
    TrackingAnalytics.send(name, { section_name: sectionName, direction: direction });
  },
  customizeTopFiveClicked (index) {
    const name = Customize('Top Five');
    TrackingAnalytics.send(name, { index: index });
  },
  customizeNoteworthyCommentClicked (index) {
    const name = Customize('Noteworthy Comment');
    TrackingAnalytics.send(name, { index: index });
  },
  didShowSegWhatTodoModal (exitState) {
    const name = CustomizeIndirectAction('Seg What To Do Modal');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  useListFromPastOccurrence () {
    const name = Customize('Seg What To Do Modal Use Last Occurrence');
    TrackingAnalytics.send(name);
  },
  downloadExisting () {
    const name = Customize('Seg What To Do Modal Download Existing List');
    TrackingAnalytics.send(name);
  },
  segWhatTodoHelp () {
    const name = Customize('Seg What To Do Modal Help');
    TrackingAnalytics.send(name);
  },
  segmentSort (columnName) {
    const name = Customize('Seg Sort');
    TrackingAnalytics.send(name, { column_name: columnName });
  },
  segmentSortByAverage () {
    this.segmentSort('average');
  },
  segmentDropdownSelected (columnName) {
    const name = Customize('Seg Dropdown');
    TrackingAnalytics.send(name, { column_name: columnName });
  },
  segmentEditClicked () {
    const name = Customize('Seg Edit');
    TrackingAnalytics.send(name);
  },
  downloadSegTemplate () {
    const name = Customize('Seg Download Template');
    TrackingAnalytics.send(name);
  },
  downloadSampleTemplate () {
    const name = Customize('Seg See Sample Template');
    TrackingAnalytics.send(name);
  },
  browseClicked () {
    const name = Customize('Seg Browse');
    TrackingAnalytics.send(name);
  },
  segInfoModal (exitState) {
    const name = CustomizeIndirectAction('Seg Info Modal');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  segInfoLearnMore () {
    const name = Customize('Seg Info Modal Learn More');
    TrackingAnalytics.send(name);
  },
  didShowSegUploadModal (exitState) {
    const name = CustomizeIndirectAction('Seg Upload Modal');
    TrackingAnalytics.send(name, { exit_state: exitState });
  },
  infoIconClicked () {
    const name = Customize('Seg Upload Modal Info');
    TrackingAnalytics.send(name);
  },
  uploadError (error) {
    const name = CustomizeIndirectAction('Seg Upload Error');
    TrackingAnalytics.send(name, { error: error });
  },
  uploadSuccess () {
    const name = CustomizeIndirectAction('Seg Upload Success');
    TrackingAnalytics.send(name);
  },
  uploadSuccessLearnMoreClicked () {
    const name = Customize('Seg Upload Success Modal Learn More');
    TrackingAnalytics.send(name);
  },
  csatModal (promptQuestion, minSinceEnd, hourSinceEnd, daySinceEnd, hasComment, rating, cancelled,
    questionId, questionEndTime) {
    TrackingAnalytics.send('CSAT Modal', {
      askWhat: promptQuestion,
      minSinceEnd,
      hourSinceEnd,
      daySinceEnd,
      hasComment,
      rating,
      cancelled,
      questionId,
      questionEnd: questionEndTime
    });
  }
};
